/**
 * Static constants for the split-payment result screens (error / try-other):
 * the recovery-option cards, provider display names, and the reserve deposit.
 * These are fixed product content, not API-driven.
 */

/**
 * session_status buckets from /split-payment/summary. The redirect URL can't be
 * trusted (Amwal always bounces to success_url; cancel_url now mirrors
 * failure_url), so session_status is the source of truth for the outcome.
 *
 * With `provider` sent to the summary the backend normalizes session_status to
 * the amwal order-status vocabulary (pending | captured | failed | canceled |
 * expired), so the mapping is: captured → success, canceled/expired → cancel,
 * everything else (failed, pending, …) → failure.
 */
export var SUCCESS_STATUSES = ["captured"];
export var CANCEL_STATUSES = ["canceled", "cancelled", "expired"];

/** Classify a session_status into the result kind. Unknown/other → failure. */
export var classifyResultStatus = function classifyResultStatus(status) {
  var s = (status || "").toLowerCase();
  if (SUCCESS_STATUSES.includes(s)) return "success";
  if (CANCEL_STATUSES.includes(s)) return "cancel";
  return "failure";
};

/** Installment provider that failed on the "try-other" screen (fallback). */
export var TRY_OTHER_PROVIDER = "تابي";

/** Provider query key → Arabic display name for the try-other headline. */
export var PROVIDER_AR_NAME = {
  tabby: "تابي",
  tamara: "تمارا",
  amwal: "أموال"
};

/** Refundable-deposit amount on the "reserve car" option. */
export var RESERVE_DEPOSIT_AMOUNT = 500;

/** Recovery-option id → `action` value for the split_payment_failed_action_select event. */
export var RESULT_ACTION_BY_ID = {
  "edit-amount": "edit_installment_amount",
  "other-provider": "change_installment_method",
  reserve: "reserve_with_deposit"
};

/** Recovery options shared by the error + try-other screens. */
export var RESULT_OPTIONS = [{
  id: "edit-amount",
  titleKey: "flexible_payment/option_edit_amount_title",
  subtitleKey: "flexible_payment/option_edit_amount_subtitle",
  href: "/site/split-payment?step=2"
}, {
  id: "other-provider",
  titleKey: "flexible_payment/option_other_provider_title",
  subtitleKey: "flexible_payment/option_other_provider_subtitle",
  href: "/site/split-payment?step=2"
}, {
  id: "reserve",
  titleKey: "flexible_payment/option_reserve_title",
  subtitleKey: "flexible_payment/option_reserve_subtitle",
  amount: RESERVE_DEPOSIT_AMOUNT,
  href: "/checkout/shop-apply"
}];